import type { ComponentSchema } from '../../../../../schema-types'
import { schema as base } from '../product/product-detail.schema'

/** Icons the trust cards draw (the theme's line icons). */
const TRUST_ICONS = [
  { label: 'Shield', value: 'shield' },
  { label: 'Exchange arrows', value: 'refresh' },
  { label: 'Lock', value: 'lock' },
  { label: 'Delivery truck', value: 'truck' },
  { label: 'Cash', value: 'cash' },
  { label: 'Parcel', value: 'package' },
  { label: 'Star', value: 'star' },
  { label: 'Tick', value: 'check' },
]

/**
 * Juta product page: the base fields plus the size chart (merchant rich text, opened from a "Size chart" link
 * beside the sizes), the "Suggested picks" rows in the summary column, the "Additional information" tab with the
 * delivery areas table, the delivery lines with green dots and the three trust cards under the buttons. All
 * optional; empty values hide their piece.
 */
export const schema: ComponentSchema = {
  ...base,
  commonFields: [
    ...base.commonFields,
    { key: 'sizeGuideTitle', label: 'Size guide link', type: 'string', default: 'Size guide', help: 'Link above the size buttons; opens the size chart inside the page.' },
    { key: 'sizeGuide', label: 'Size guide', type: 'rich-text', help: 'Tables and fit notes shown inline under the sizes; while empty the theme\'s EU / UK / US / cm chart shows.' },
    { key: 'completeTheLookTitle', label: '"You may also like" title', type: 'string', default: 'You may also like', help: 'Rail of up to 8 same-category products under the page.' },
    { key: 'additionalInfoTitle', label: '"Specifications" title', type: 'string', default: 'Specifications', help: 'Accordion with the options and the variation summary.' },
    { key: 'showDeliveryAreas', label: 'Show delivery areas and charges', type: 'boolean', default: true },
    {
      key: 'deliveryPoints',
      label: 'Delivery lines',
      type: 'array',
      help: 'Lines in the delivery box (truck icon).',
      itemSchema: [{ key: 'text', label: 'Line', type: 'string' }],
      default: [
        { text: 'Delivery all over Bangladesh' },
        { text: 'Cash on delivery available' },
        { text: 'Check the parcel before you pay' },
      ],
    },
    {
      key: 'trustCards',
      label: 'Trust cards',
      type: 'array',
      help: 'Up to three items in the green strip under the buttons.',
      itemSchema: [
        { key: 'icon', label: 'Icon', type: 'select', options: TRUST_ICONS, default: 'shield' },
        { key: 'title', label: 'Title', type: 'string' },
        { key: 'text', label: 'Line', type: 'string' },
      ],
      default: [
        { icon: 'shield', title: 'Checked pair by pair', text: 'Every pair inspected before it ships' },
        { icon: 'refresh', title: 'Easy size swap', text: 'Wrong size? Swap it within 7 days' },
        { icon: 'lock', title: 'Safe payment', text: 'Pay on delivery or online' },
      ],
    },
  ],
}
